// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"646":"e6ed7a30","790":"22e73cde"}[chunkId] + ".chunk.js";
};